import axios from "axios";
import {APP_DISPLAY_ADS_API_ENDPOINT} from "../../../../constants/api_urls";
import {getUserToken} from "../../../../utils/functions/userToken";

export const saveCampaignSettings = async (payload) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.put(
            `${APP_DISPLAY_ADS_API_ENDPOINT}/api/display-ads/edit-campaign/settings/`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        const errors = {};

        const responseData = error.response?.data?.edit_campaign_settings || {};

        if (responseData.campaign_name?.errorMessage) {
            errors.campaignName = responseData.campaign_name.errorMessage;
        }

        if (Array.isArray(responseData.campaign_lang) && responseData.campaign_lang[0]?.errorMessage) {
            errors.campaignLang = responseData.campaign_lang[0].errorMessage;
        }
        const customError = new Error("Validation Error");
        customError.errors = errors;
        customError.originalError = error;
        throw customError;
    }
};
